module.exports = __webpack_public_path__ + "media/bg.0d212cbf.mp4";